<template>
    <div class="product">
        <div class="my-content" v-viewer="vViewerOptions">
            <div class="columns">
                <div class="column">
                    <h1 class="title is-5">ລາຍການສິນຄ້າ</h1>
                </div>
                <div class="column has-text-right">
                    <b-button class="is-small"
                              type="is-twitter"
                              icon-left="plus"
                              :disabled="selectedProduct"
                              @click="isModalActive = true">ເພີ່ມສິນຄ້າ
                    </b-button>
                    <b-button v-if="selectedProduct" class="ml-2 is-small"
                              type="is-warning"
                              icon-left="cancel"
                              @click="resetForm">ລ້າງລາຍການທີ່ເລືອກ
                    </b-button>
                    <b-button class="ml-2 is-small"
                              type="is-success"
                              icon-left="pencil-outline"
                              :disabled="!selectedProduct"
                              @click="crud('EDIT')">ແກ້ໄຂ
                    </b-button>
                    <b-button class="ml-2 is-small"
                              type="is-danger"
                              icon-left="trash-can-outline"
                              :disabled="!selectedProduct"
                              @click="crud('REMOVE')">ລຶບ
                    </b-button>
                </div>
            </div>
            <table-skeleton :has-image="true" v-if="products.length === 0"/>
            <b-field v-if="products.length > 0">
                <b-input placeholder="ຄົ້ນຫາ" v-model="search"/>
            </b-field>
            <b-table v-if="products.length > 0"
                     :data="filter"
                     class="database-table"
                     striped
                     paginated
                     per-page="20"
                     :current-page.sync="currentPage"
                     :selected.sync="selectedProduct"
                     :default-sort-direction="defaultSortDirection"
                     :sort-icon="sortIcon"
                     :sort-icon-size="sortIconSize"
                     :loading="isLoading"
                     default-sort="created"
                     ref="databaseTable">
                <b-table-column width="8%" v-slot="props">
                    <b-skeleton v-if="props.row.image && !imageLoaded" height="60" width="60"></b-skeleton>
                    <transition>
                        <img class="image-temp" v-if="props.row.image" :src="props.row.image" :alt="props.row.name"
                             width="60" @load="onImageLoad" v-show="imageLoaded"/>
                        <img class="image-temp"
                             v-if="!props.row.image"
                             src="@/assets/images/thumbnail.png"
                             :alt="props.row.name" width="60"
                             @load="onImageLoad"
                             v-show="imageLoaded">
                    </transition>
                </b-table-column>
                <b-table-column width="12%" label="ລະຫັດສິນນຄ້າ" sortable field="id" v-slot="props">
                    <p>{{ props.row.code }}</p>
                </b-table-column>
                <b-table-column label="ຊື່ສິນຄ້າ" sortable field="name" v-slot="props">
                    <p>{{ props.row.name }}</p>
                </b-table-column>
                <b-table-column label="ລາຍຄາ" sortable field="price" v-slot="props">
                    <strong>{{ props.row.price | formatMoney }}</strong> ກີບ
                </b-table-column>
                <b-table-column label="ຈໍານວນ" sortable field="qty" v-slot="props">
                    <p>{{ props.row.qty }}</p>
                </b-table-column>
                <b-table-column label="ໝວດສິນຄ້າ" sortable field="category" v-slot="props">
                    <p>{{ props.row.category }}</p>
                </b-table-column>
                <b-table-column width="10%" class="has-text-centered" sortable label="ມີໃນສະຕ໋ອກ" v-slot="props">
                    <b-switch
                            v-model="props.row.instock"
                            :value="props.row.instock"
                            :true-value="true"
                            :false-value="false"
                            :disabled="parseInt(props.row.qty) === 0"
                            @input="crud('STOCK')">
                    </b-switch>
                </b-table-column>
            </b-table>
        </div>

        <b-modal v-model="isModalActive"
                 has-modal-card
                 trap-focus
                 :destroy-on-hide="false"
                 aria-role="dialog"
                 :can-cancel="false">
            <div class="modal-card" style="width: auto; overflow-y: auto;">
                <form @submit.prevent="submit()">
                    <header class="modal-card-head">
                        <p class="modal-card-title">ເພີ່ມສິນຄ້າ</p>
                    </header>
                    <section class="modal-card-body">
                        <b-field label="ລະຫັດສິນຄ້າ">
                            <b-input v-model="product.code"
                                     placeholder="ປ້ອນລະຫັດສິນຄ້າ"
                                     :readonly="!isEditing"
                                     required
                                     validation-message="ຕ້ອງປ້ອນລະຫັດສິນຄ້າ"></b-input>
                        </b-field>
                        <div class="columns">
                            <div class="column">
                                <b-field label="ໝວດສິນຄ້າ">
                                    <b-select v-model="product.category" placeholder="ເລືອກໝວດສິນຄ້າ"
                                              expanded
                                              required
                                              validation-message="ຕ້ອງເລືອກໝວດສິນຄ້າ">
                                        <option
                                                v-for="option in categories"
                                                :value="option.name"
                                                :key="option.code">
                                            {{ option.name }}
                                        </option>
                                    </b-select>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field label="ຊື່ສິນຄ້າ">
                                    <b-input v-model="product.name"
                                             placeholder="ປ້ອນຊື່ສິນຄ້າ"
                                             required
                                             validation-message="ຕ້ອງປ້ອນຊື່ສິນຄ້າ"></b-input>
                                </b-field>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <b-field label="ລາຄາ">
                                    <b-input v-model="product.price"
                                             placeholder="ປ້ອນລາຄາ"
                                             v-cleave="masks.numeral"
                                             required
                                             validation-message="ຕ້ອງປ້ອນລາຄາ"
                                             @keypress.native="onInputNumber"></b-input>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field label="ຈໍານວນ">
                                    <b-input v-model="product.qty"
                                             placeholder="ປ້ອນຈໍານວນ"
                                             v-cleave="masks.numeralOnly"
                                             required
                                             validation-message="ຕ້ອງປ້ອນຈໍານວນ"
                                             @keypress.native="onInputNumber"></b-input>
                                </b-field>
                            </div>
                        </div>
                        <div class="field">
                            <b-switch v-model="product.instock">ມີໃນສະຕ໋ອກ</b-switch>
                        </div>
                        <div class="columns">
                            <div class="column" style="min-width: 300px;">
                                <b-field>
                                    <b-upload drag-drop
                                              expanded
                                              accept="image/*"
                                              ref="productImage"
                                              @input.native="previewImage"
                                              :disabled="!product.code">
                                        <section class="section">
                                            <div class="content has-text-centered">
                                                <p>
                                                    <b-icon icon="upload" size="is-large"></b-icon>
                                                </p>
                                                <p>ວ່າງຟາຍລ໌ໃສ່ບ່ອນນີ້ ຫຼື ກົດເພື່ອອັບໂຫຼດ</p>
                                            </div>
                                        </section>
                                    </b-upload>
                                </b-field>
                                <b-progress v-if="imageData" :value="uploadProgress" show-value format="percent"
                                            class="is-success"></b-progress>
                            </div>
                            <div class="column" style="min-width: 300px;">
                                <div v-if="product.image" style="max-width: 300px;">
                                    <img :src="product.image" alt="Product Image Preview" width="100%"/>
                                </div>
                            </div>
                        </div>
                    </section>
                    <footer class="modal-card-foot">
                        <b-button type="is-primary"
                                  class="button"
                                  icon-left="content-save-edit-outline"
                                  expanded
                                  native-type="submit">ບັນທືກ
                        </b-button>
                        <b-button type="is-danger"
                                  icon-left="close-circle"
                                  expanded
                                  @click="resetForm">ຍົກເລີກ
                        </b-button>
                    </footer>
                </form>
            </div>
        </b-modal>

        <viewer :title="false"></viewer>
    </div>
</template>

<script>
    import {categoriesCollection, productsCollection, productsHistoryCollection, storage} from '../firebase';
    import Cleave from 'cleave.js'
    import "viewerjs/dist/viewer.css";
    import Viewer from "v-viewer";
    import Vue from "vue";
    import TableSkeleton from "../components/TableSkeleton";

    Vue.use(Viewer);

    const cleave = {
        name: 'cleave',
        bind(el, binding) {
            const input = el.querySelector('input');
            input._vCleave = new Cleave(input, binding.value)
        },
        unbind(el) {
            const input = el.querySelector('input');
            input._vCleave.destroy()
        }
    };

    export default {
        name: "Products",
        components: {TableSkeleton},
        directives: {cleave},
        data() {
            return {
                isModalActive: false,
                defaultSortDirection: 'asc',
                sortIcon: 'arrow-up',
                sortIconSize: 'is-small',
                isLoading: false,
                isEditing: false,
                search: '',
                categories: [],
                products: [],
                lastProduct: [],
                currentPage: 1,
                vViewerOptions: {
                    title: false,
                    loop: false,
                    zoomable: true,
                    fullscreen: false,
                    toolbar: {
                        zoomIn: true,
                        zoomOut: true,
                        // oneToOne: true,
                        reset: true,
                        prev: true,
                        play: {
                            show: false,
                            // size: "large"
                        },
                        next: true,
                        rotateLeft: true,
                        rotateRight: true,
                        flipHorizontal: true,
                        flipVertical: true,
                    },
                },
                masks: {
                    numeral: {
                        numeral: true,
                        numeralThousandsGroupStyle: 'thousand',
                        //prefix: '₭ '
                    },
                    numeralOnly: {
                        numeral: true,
                        numeralDecimalMark: '',
                        delimiter: '',
                    },
                },
                product: {
                    category: null,
                    code: null,
                    name: null,
                    price: 0,
                    qty: 0,
                    instock: true,
                    image: null
                },
                selectedCategory: null,
                selectedProduct: null,
                imageData: null,
                uploadProgress: 0,
                isExisted: false,
                imageLoaded: false,
            }
        },
        firestore() {
            return {
                categories: categoriesCollection.where('deleted', '==', false).orderBy('created', 'desc'),
                products: productsCollection.where('deleted', '==', false).orderBy('created', 'desc'),
                lastProduct: productsCollection.orderBy('created', 'desc').limit(1)
            }
        },
        computed: {
            filter: function () {
                const search = new RegExp(this.search, 'i')
                let data = []
                for (let i in this.products) {
                    if (this.products[i].name.match(search) || this.products[i].code.match(search) || this.products[i].qty.match(search) || this.products[i].price.match(search) || this.products[i].category.match(search)) {
                        data.push(this.products[i])
                    }
                }
                return data
            }
        },
        methods: {
            getProductById: async function (code) {
                const snapshot = productsCollection.where('code', '==', code).get();
                const productQuerySnapshot = await Promise.resolve(snapshot);
                return productQuerySnapshot.docs
            },
            previewImage(event) {
                this.imageData = event.target.files[0];
                console.log("IMAGE DATA", this.imageData);
                this.onUpload();
            },
            onUpload() {
                this.product.image = null;
                const filename = this.product.code + '.' + this.imageData.name.split('.').pop();
                const storageRef = storage.ref(`${filename}`).put(this.imageData);
                storageRef.on(`state_changed`, snapshot => {
                        this.uploadProgress = Math.floor(snapshot.bytesTransferred / snapshot.totalBytes * 100);
                    }, error => {
                        console.log(error.message)
                    },
                    () => {
                        this.uploadProgress = 100;
                        storageRef.snapshot.ref.getDownloadURL().then((url) => {
                            this.imageData = null;
                            this.product.image = url;
                            console.log("IMAGE URL", this.product.image)
                        });
                    }
                );
            },
            onImageLoad() {
                this.imageLoaded = true;
            },
            crud(action) {
                if (action === 'EDIT') {
                    this.isEditing = true;
                    this.product.category = this.selectedProduct.category;
                    this.product.code = this.selectedProduct.code;
                    this.product.name = this.selectedProduct.name;
                    this.product.price = this.selectedProduct.price;
                    this.product.qty = this.selectedProduct.qty;
                    this.product.instock = this.selectedProduct.instock;
                    this.product.image = this.selectedProduct.image;
                    this.isModalActive = true;
                }
                if (action === 'STOCK') {
                    productsCollection.doc(this.selectedProduct.id).update({instock: this.selectedProduct.instock})
                        .then(docRef => {
                            console.log(docRef);
                        })
                        .catch(err => {
                            console.log(err);
                        })
                }
                if (action === 'REMOVE') {
                    this.$swal({
                        text: "ຕ້ອງການລຶບສິນຄ້າ " + this.selectedProduct.name + " ແທ້ບໍ່?!",
                        icon: 'warning',
                        showCancelButton: true,
                    }).then((result) => {
                        if (result.value) {
                            this.isLoading = true;
                            productsCollection.doc(this.selectedProduct.id).update({deleted: true})
                                .then(docRef => {
                                    console.log(docRef);
                                    this.resetForm();
                                })
                                .catch(err => {
                                    console.log(err);
                                })
                        }
                    })
                }
            },
            submit: async function () {
                if (this.selectedProduct) {
                    await this.update();
                    return
                }

                await this.getProductById(this.product.code).then(res => {
                    this.isExisted = false
                    res.forEach(docSnapshot => {
                        const existedItem = docSnapshot.data();
                        if (existedItem) {
                            this.$swal('', 'ມີລະຫັດສິນຄ້າ ' + this.product.code + ' ແລ້ວ!!', 'error');
                            this.isLoading = false;
                            this.isExisted = true
                        }
                    })
                })

                if (!this.isExisted) {
                    const req = {
                        ...this.product,
                        qty: parseInt(this.product.qty),
                        price: this.product.price.replace(',', ''),
                        created: this.getCurrentDateTime(),
                        deleted: false
                    };

                    productsCollection.add(req)
                        .then(docRef => {
                            console.log(docRef.id);
                            this.$buefy.snackbar.open(`ການດໍາເນີນການສໍາເລັດ`)
                            this.resetForm();
                        })
                        .catch(err => {
                            console.log(err);
                            this.$swal('', err, 'error')
                        })
                }
            },
            update: async function () {
                await this.getProductById(this.product.code).then(res => {
                    this.isExisted = false
                    res.forEach(docSnapshot => {
                        const existedItem = docSnapshot.data();
                        if (existedItem && existedItem.code !== this.selectedProduct.code) {
                            this.$swal('', 'ມີລະຫັດສິນຄ້າ ' + this.product.code + ' ແລ້ວ!!', 'error');
                            this.isLoading = false;
                            this.isExisted = true
                        }
                    })
                })

                if (!this.isExisted) {
                    const req = {
                        ...this.product,
                        qty: parseInt(this.product.qty),
                        price: this.product.price.replace(',', '')
                    };

                    //TODO: db.runTransaction

                    const editProduct = productsCollection.doc(this.selectedProduct.id).update(req)
                        .then(docRef => {
                            console.log(docRef);
                        })
                        .catch(err => {
                            console.log(err);
                            this.$swal('', err, 'error')
                        })

                    const addProductHistory = productsHistoryCollection.add({
                        ...req,
                        created: this.getCurrentDateTime()
                    }).then(docRef => {
                        console.log("HISTORY", docRef);
                    }).catch(err => {
                        console.log(err);
                        this.$swal('', err, 'error')
                    })

                    Promise.all([editProduct, addProductHistory]).then(res => {
                        console.log("PROMISE SUCCESS", res);
                        this.$buefy.snackbar.open(`ການດໍາເນີນການສໍາເລັດ`)
                        this.resetForm();
                    }).catch(err => {
                        console.log("PROMISE ERROR", err);
                        this.$swal('', err, 'error')
                    })
                }
            },
            onInputNumber(e) {
                const charCode = e.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    e.preventDefault();
                } else {
                    return true;
                }
            },
            resetForm() {
                this.isLoading = false;
                this.isEditing = false;
                this.isModalActive = false;
                this.product.code = null;
                this.product.name = null;
                this.product.price = 0;
                this.product.qty = 0;
                this.product.image = null;
                this.selectedProduct = null;
                this.imageData = null;
                this.uploadProgress = 0;
            },
        },
        watch: {
            isModalActive(val) {
                if (val) {
                    if (!this.isEditing) {
                        this.product.code = this.getInvoiceNumber(parseInt(this.lastProduct[0].code) + 1);
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .product {

    }

    .image-temp:hover {
        cursor: pointer;
    }
</style>